// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  AddTrajectoryPointsData,
  AddTrajectoryPointsErrors,
  AddTrajectoryPointsResponses,
  CreateAdditionalQuotaData,
  CreateAdditionalQuotaErrors,
  CreateAdditionalQuotaResponses,
  CreateFileData,
  CreateFileErrors,
  CreateFileResponses,
  CreateImageDatasetsData,
  CreateImageDatasetsErrors,
  CreateImageDatasetsResponses,
  CreateIngestionData,
  CreateIngestionErrors,
  CreateIngestionResponses,
  CreatePointcloudData,
  CreatePointcloudErrors,
  CreatePointcloudImportData,
  CreatePointcloudImportErrors,
  CreatePointcloudImportResponses,
  CreatePointcloudResponses,
  CreateProjectData,
  CreateProjectErrors,
  CreateProjectResponses,
  CreateStationData,
  CreateStationErrors,
  CreateStationResponses,
  CreateTrajectoryData,
  CreateTrajectoryResponses,
  DeleteClassificationSchemesData,
  DeleteClassificationSchemesErrors,
  DeleteClassificationSchemesResponses,
  DeleteImageDatasetData,
  DeleteImageDatasetErrors,
  DeleteImageDatasetResponses,
  ExportPointcloudData,
  ExportPointcloudErrors,
  ExportPointcloudResponses,
  ExportSupportPointcloudsData,
  ExportSupportPointcloudsErrors,
  ExportSupportPointcloudsResponses,
  GetAccountInfoData,
  GetAccountInfoErrors,
  GetAccountInfoResponses,
  GetAccountQuotaData,
  GetAccountQuotaErrors,
  GetAccountQuotaResponses,
  GetactivejobsData,
  GetactivejobsResponses,
  GetAdditionalQuotaData,
  GetAdditionalQuotaErrors,
  GetAdditionalQuotaResponses,
  GetByProjectIdData,
  GetByProjectIdErrors,
  GetByProjectIdResponses,
  GetClassificationData,
  GetClassificationErrors,
  GetClassificationResponses,
  GetExportData,
  GetExportErrors,
  GetExportResponses,
  GetImportData,
  GetImportErrors,
  GetImportResponses,
  GetIngestionData,
  GetIngestionErrors,
  GetIngestionResponses,
  GetJobData,
  GetJobErrors,
  GetJobResponses,
  GetLicensesData,
  GetLicensesErrors,
  GetLicensesResponses,
  GetmeData,
  GetmeErrors,
  GetmeResponses,
  GetPointcloudData,
  GetPointcloudErrors,
  GetPointcloudResponses,
  GetProjectAllowedPermissionsData,
  GetProjectAllowedPermissionsResponses,
  GetProjectData,
  GetProjectErrors,
  GetProjectPermissionsData,
  GetProjectPermissionsResponses,
  GetProjectQuotaData,
  GetProjectQuotaErrors,
  GetProjectQuotaResponses,
  GetProjectQuotasData,
  GetProjectQuotasErrors,
  GetProjectQuotasResponses,
  GetProjectResponses,
  GetProjectTagsData,
  GetProjectTagsResponses,
  GetSettingData,
  GetSettingErrors,
  GetSettingResponses,
  GetSparkPoolData,
  GetSparkPoolResponses,
  GetSupportMeData,
  GetSupportMeResponses,
  GetSupportProjectData,
  GetSupportProjectErrors,
  GetSupportProjectResponses,
  GetTilesetData,
  GetTilesetErrors,
  GetTilesetResponses,
  GetUsageSummaryPointcloudsData,
  GetUsageSummaryPointcloudsErrors,
  GetUsageSummaryPointcloudsResponses,
  GetUsageSummaryProjectsData,
  GetUsageSummaryProjectsErrors,
  GetUsageSummaryProjectsResponses,
  GetUsageSummaryStorageData,
  GetUsageSummaryStorageErrors,
  GetUsageSummaryStorageResponses,
  GetUsageSummaryUploadersData,
  GetUsageSummaryUploadersErrors,
  GetUsageSummaryUploadersResponses,
  ListAdditionalQuotasData,
  ListAdditionalQuotasErrors,
  ListAdditionalQuotasResponses,
  ListClassifiersData,
  ListClassifiersErrors,
  ListClassifiersResponses,
  ListFilesData,
  ListFilesErrors,
  ListFilesResponses,
  ListJobsData,
  ListJobsErrors,
  ListJobsResponses,
  ListPointcloudsData,
  ListPointcloudsErrors,
  ListPointcloudsResponses,
  ListPreviewsData,
  ListPreviewsErrors,
  ListPreviewsResponses,
  ListProjectsData,
  ListProjectsResponses,
  ListRegionsData,
  ListRegionsResponses,
  ListSettingData,
  ListSettingErrors,
  ListSettingResponses,
  ListStationsData,
  ListStationsErrors,
  ListStationsResponses,
  ListSupportFeaturesData,
  ListSupportFeaturesResponses,
  ListSupportPointcloudsData,
  ListSupportPointcloudsErrors,
  ListSupportPointcloudsResponses,
  ListTilesetsData,
  ListTilesetsErrors,
  ListTilesetsResponses,
  ListUsersData,
  ListUsersErrors,
  ListUsersResponses,
  MigrationFixPointcloudDuplicateUsagesData,
  MigrationFixPointcloudDuplicateUsagesResponses,
  MigrationPointcloudFilesAndStationsData,
  MigrationPointcloudFilesAndStationsResponses,
  MigrationPointcloudNullStatusData,
  MigrationPointcloudNullStatusResponses,
  PatchPointcloudData,
  PatchPointcloudErrors,
  PatchPointcloudResponses,
  PatchProjectData,
  PatchProjectErrors,
  PatchProjectResponses,
  PatchSettingData,
  PatchSettingErrors,
  PatchSettingResponses,
  PutSettingData,
  PutSettingErrors,
  PutSettingResponses,
  RemoveAdditionalQuotaData,
  RemoveAdditionalQuotaErrors,
  RemoveAdditionalQuotaResponses,
  RemovePointcloudData,
  RemovePointcloudErrors,
  RemovePointcloudResponses,
  RemoveProjectData,
  RemoveProjectErrors,
  RemoveProjectResponses,
  RemoveSettingData,
  RemoveSettingErrors,
  RemoveSettingResponses,
  RestorePointcloudData,
  RestorePointcloudErrors,
  RestorePointcloudResponses,
  SupportCreateIngestionData,
  SupportCreateIngestionErrors,
  SupportCreateIngestionResponses,
  UpdateClassificationSchemesData,
  UpdateClassificationSchemesErrors,
  UpdateClassificationSchemesResponses,
  UpdateStationsData,
  UpdateStationsErrors,
  UpdateStationsResponses,
  UsageSyncData,
  UsageSyncErrors,
  UsageSyncResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get Account Quota info
 *
 * Route to get Account Quota metadata.
 */
export const getAccountQuota = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountQuotaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetAccountQuotaResponses,
    GetAccountQuotaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/quota',
    ...options,
  });

/**
 * Delete classification schemes
 *
 * Reset the pointcloud classification schemes to default.
 */
export const deleteClassificationSchemes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<DeleteClassificationSchemesData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteClassificationSchemesResponses,
    DeleteClassificationSchemesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/classifications',
    ...options,
  });

/**
 * Get classification scheme
 *
 * Returns classification schemes.
 */
export const getClassification = <ThrowOnError extends boolean = false>(
  options: Options<GetClassificationData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetClassificationResponses,
    GetClassificationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/classifications',
    ...options,
  });

/**
 * Update Pointcloud classification schemes
 *
 * Update pointcloud classification schemes.
 */
export const updateClassificationSchemes = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UpdateClassificationSchemesData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateClassificationSchemesResponses,
    UpdateClassificationSchemesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/classifications',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List classifiers
 *
 * Returns a list of classifier metadata.
 */
export const listClassifiers = <ThrowOnError extends boolean = false>(
  options: Options<ListClassifiersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListClassifiersResponses,
    ListClassifiersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/classifiers',
    ...options,
  });

/**
 * Start Pointcloud Export Task.
 *
 * Route to create a Pointcloud export request.
 */
export const exportPointcloud = <ThrowOnError extends boolean = false>(
  options: Options<ExportPointcloudData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExportPointcloudResponses,
    ExportPointcloudErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/exports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Export info
 *
 * Route to get Export metadata icluding creation status.
 */
export const getExport = <ThrowOnError extends boolean = false>(
  options: Options<GetExportData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetExportResponses,
    GetExportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/exports/{exportId}',
    ...options,
  });

/**
 * List Files
 *
 * Route to list Files.
 */
export const listFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListFilesResponses,
    ListFilesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/files',
    ...options,
  });

/**
 * Create File
 *
 * Route to request the creation of Files.
 */
export const createFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateFileData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateFileResponses,
    CreateFileErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/files',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get the project region info based on a projectId
 *
 * Find SDS region info for a particular projectId.
 */
export const getByProjectId = <ThrowOnError extends boolean = false>(
  options: Options<GetByProjectIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetByProjectIdResponses,
    GetByProjectIdErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/global/projects/{projectId}',
    ...options,
  });

/**
 * Lists all scan data regions available.
 *
 * Returns a list of all SDS regions & their information.
 */
export const listRegions = <ThrowOnError extends boolean = false>(
  options: Options<ListRegionsData, ThrowOnError>
) =>
  (options.client ?? client).get<ListRegionsResponses, unknown, ThrowOnError>({
    url: '/global/regions',
    ...options,
  });

/**
 * Create Image Datasets
 *
 * Route to request the creation of Image Datasets.
 */
export const createImageDatasets = <ThrowOnError extends boolean = false>(
  options: Options<CreateImageDatasetsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateImageDatasetsResponses,
    CreateImageDatasetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/imagedatasets',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Image Dataset
 *
 * Route to delete an Image Dataset from a Pointcloud.
 */
export const deleteImageDataset = <ThrowOnError extends boolean = false>(
  options: Options<DeleteImageDatasetData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DeleteImageDatasetResponses,
    DeleteImageDatasetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/imagedatasets/{imageDatasetId}',
    ...options,
  });

/**
 * Create Pointcloud import
 *
 * Route to request an import to provide content for a Pointcloud.
 */
export const createPointcloudImport = <ThrowOnError extends boolean = false>(
  options: Options<CreatePointcloudImportData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePointcloudImportResponses,
    CreatePointcloudImportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/imports',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Import info
 *
 * Route to get Import metadata icluding creation status.
 */
export const getImport = <ThrowOnError extends boolean = false>(
  options: Options<GetImportData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetImportResponses,
    GetImportErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/imports/{importId}',
    ...options,
  });

/**
 * Create Ingestion
 *
 * Route to request the creation of a Ingestion.
 */
export const createIngestion = <ThrowOnError extends boolean = false>(
  options: Options<CreateIngestionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateIngestionResponses,
    CreateIngestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/ingestions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Ingestion info
 *
 * Route to get Ingestion metadata icluding creation status.
 */
export const getIngestion = <ThrowOnError extends boolean = false>(
  options: Options<GetIngestionData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetIngestionResponses,
    GetIngestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/ingestions/{ingestionId}',
    ...options,
  });

/**
 * Get active scan licenses for project
 *
 * Get active scan licenses for project
 */
export const getLicenses = <ThrowOnError extends boolean = false>(
  options: Options<GetLicensesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetLicensesResponses,
    GetLicensesErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/licenses',
    ...options,
  });

/**
 * Get My Project Info
 *
 * Route to get current user project info.
 */
export const getme = <ThrowOnError extends boolean = false>(
  options: Options<GetmeData, ThrowOnError>
) =>
  (options.client ?? client).get<GetmeResponses, GetmeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users/me',
    ...options,
  });

/**
 * Get Project Allowed Permissions
 *
 * Route to get Project allowed Permissions.
 */
export const getProjectPermissions = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectPermissionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectPermissionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/permissions',
    ...options,
  });

/**
 * List Pointclouds
 *
 * Returns a list of Pointcloud metadata.
 */
export const listPointclouds = <ThrowOnError extends boolean = false>(
  options: Options<ListPointcloudsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPointcloudsResponses,
    ListPointcloudsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds',
    ...options,
  });

/**
 * Create a new Pointcloud
 *
 * Route to create a Pointcloud.
 */
export const createPointcloud = <ThrowOnError extends boolean = false>(
  options: Options<CreatePointcloudData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreatePointcloudResponses,
    CreatePointcloudErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Delete Pointcloud
 *
 * Marks the pointcloud as deleted. If permanent is blank or false (the default) the pointcloud can be restored. If permanent is true the pointcloud is deleted permanently and cannot be restored.
 */
export const removePointcloud = <ThrowOnError extends boolean = false>(
  options: Options<RemovePointcloudData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemovePointcloudResponses,
    RemovePointcloudErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}',
    ...options,
  });

/**
 * Get Pointcloud info
 *
 * Returns metadata about a Pointcloud.
 */
export const getPointcloud = <ThrowOnError extends boolean = false>(
  options: Options<GetPointcloudData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetPointcloudResponses,
    GetPointcloudErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}',
    ...options,
  });

/**
 * Update Pointcloud info
 *
 * Route to update an existing Pointcloud.
 */
export const patchPointcloud = <ThrowOnError extends boolean = false>(
  options: Options<PatchPointcloudData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchPointcloudResponses,
    PatchPointcloudErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Restore Pointcloud
 *
 * Route to restore a deleted Pointcloud.
 */
export const restorePointcloud = <ThrowOnError extends boolean = false>(
  options: Options<RestorePointcloudData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RestorePointcloudResponses,
    RestorePointcloudErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/restore',
    ...options,
  });

/**
 * List Previews
 *
 * Returns a list of previews.
 */
export const listPreviews = <ThrowOnError extends boolean = false>(
  options: Options<ListPreviewsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListPreviewsResponses,
    ListPreviewsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/previews',
    ...options,
  });

/**
 * List Project Tenancies
 *
 * Route to list the user's Connect Projects and their tenant status.
 */
export const listProjects = <ThrowOnError extends boolean = false>(
  options: Options<ListProjectsData, ThrowOnError>
) =>
  (options.client ?? client).get<ListProjectsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
  });

/**
 * Create a Scan Data Services tenancy
 *
 * Route to provision a Connect Project Tenancy. Create a project from https://web.connect.trimble.com (or https://web.stage.connect.trimble.com)
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateProjectResponses,
    CreateProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Remove Project Tenancy
 *
 * Route to remove a Project Tenancy, and all Pointclouds and their data.
 */
export const removeProject = <ThrowOnError extends boolean = false>(
  options: Options<RemoveProjectData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveProjectResponses,
    RemoveProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
  });

/**
 * Get Project Tenancy info
 *
 * Route to get Project Tenancy metadata.
 */
export const getProject = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectResponses,
    GetProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
  });

/**
 * Update Project info
 *
 * Route to update an existing Project.
 */
export const patchProject = <ThrowOnError extends boolean = false>(
  options: Options<PatchProjectData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchProjectResponses,
    PatchProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Project Allowed Permissions
 *
 * Route to get Project allowed Permissions.
 */
export const getProjectAllowedPermissions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetProjectAllowedPermissionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectAllowedPermissionsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/permissions',
    ...options,
  });

/**
 * Get Project Quota info
 *
 * Route to get Project Quota metadata.
 */
export const getProjectQuota = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectQuotaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectQuotaResponses,
    GetProjectQuotaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/quota',
    ...options,
  });

/**
 * Get Project Tags
 *
 * Route to get a distinct list of Project Pointcloud tags.
 */
export const getProjectTags = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectTagsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectTagsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/tags',
    ...options,
  });

/**
 * Sync project usage information.
 *
 * Route to sync project usage information.
 */
export const usageSync = <ThrowOnError extends boolean = false>(
  options: Options<UsageSyncData, ThrowOnError>
) =>
  (options.client ?? client).post<
    UsageSyncResponses,
    UsageSyncErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/usageSync',
    ...options,
  });

/**
 * Get the storage quota information associated with the Project.
 *
 * Return the maximum storage quota, the storage consumed by the project and total storage consumed by the project account, in the unit of bytes.
 */
export const getProjectQuotas = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectQuotasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetProjectQuotasResponses,
    GetProjectQuotasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/quotas',
    ...options,
  });

/**
 * Remove Setting info
 *
 * Route to remove a saved Setting
 */
export const removeSetting = <ThrowOnError extends boolean = false>(
  options: Options<RemoveSettingData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveSettingResponses,
    RemoveSettingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings/{key}',
    ...options,
  });

/**
 * Get Setting info
 *
 * Route to get a saved Setting
 */
export const getSetting = <ThrowOnError extends boolean = false>(
  options: Options<GetSettingData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSettingResponses,
    GetSettingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings/{key}',
    ...options,
  });

/**
 * Update Setting info
 *
 * Route to patch a saved Setting
 */
export const patchSetting = <ThrowOnError extends boolean = false>(
  options: Options<PatchSettingData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    PatchSettingResponses,
    PatchSettingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings/{key}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Setting info
 *
 * Route to replace a saved Setting
 */
export const putSetting = <ThrowOnError extends boolean = false>(
  options: Options<PutSettingData, ThrowOnError>
) =>
  (options.client ?? client).put<
    PutSettingResponses,
    PutSettingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings/{key}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List Settings
 *
 * Route to get a list of Settings.
 */
export const listSetting = <ThrowOnError extends boolean = false>(
  options: Options<ListSettingData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListSettingResponses,
    ListSettingErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/settings',
    ...options,
  });

/**
 * List Stations
 *
 * Route to list Stations.
 */
export const listStations = <ThrowOnError extends boolean = false>(
  options: Options<ListStationsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListStationsResponses,
    ListStationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/stations',
    ...options,
  });

/**
 * Create Station
 *
 * Route to request the creation of Stations.
 */
export const createStation = <ThrowOnError extends boolean = false>(
  options: Options<CreateStationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateStationResponses,
    CreateStationErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/stations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Update Pointcloud stations
 *
 * Route to update stations of an existing Pointcloud.
 */
export const updateStations = <ThrowOnError extends boolean = false>(
  options: Options<UpdateStationsData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UpdateStationsResponses,
    UpdateStationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/stations',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get account info.
 *
 * Returns the detail of a connect project account.
 */
export const getAccountInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetAccountInfoData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetAccountInfoResponses,
    GetAccountInfoErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/accounts/{accountId}',
    ...options,
  });

/**
 * Get My Active Job Stats
 *
 * Route to get active jobs of current user.
 */
export const getactivejobs = <ThrowOnError extends boolean = false>(
  options: Options<GetactivejobsData, ThrowOnError>
) =>
  (options.client ?? client).get<GetactivejobsResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/support/activejobs',
      ...options,
    }
  );

/**
 * Remove an additional quota
 *
 * Route to remove an additional quota.
 */
export const removeAdditionalQuota = <ThrowOnError extends boolean = false>(
  options: Options<RemoveAdditionalQuotaData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RemoveAdditionalQuotaResponses,
    RemoveAdditionalQuotaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/additionalquota',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get an additional quota.
 *
 * Route to get an additional quota.
 */
export const getAdditionalQuota = <ThrowOnError extends boolean = false>(
  options: Options<GetAdditionalQuotaData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetAdditionalQuotaResponses,
    GetAdditionalQuotaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/additionalquota',
    ...options,
  });

/**
 * Add more quota.
 *
 * Route to add additional quota.
 */
export const createAdditionalQuota = <ThrowOnError extends boolean = false>(
  options: Options<CreateAdditionalQuotaData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateAdditionalQuotaResponses,
    CreateAdditionalQuotaErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/additionalquota',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * List additional quotas.
 *
 * Returns a list of additional quotas.
 */
export const listAdditionalQuotas = <ThrowOnError extends boolean = false>(
  options?: Options<ListAdditionalQuotasData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListAdditionalQuotasResponses,
    ListAdditionalQuotasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/additionalquotas',
    ...options,
  });

/**
 * List Features
 *
 * Admin route to list features.
 */
export const listSupportFeatures = <ThrowOnError extends boolean = false>(
  options?: Options<ListSupportFeaturesData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListSupportFeaturesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/features',
    ...options,
  });

/**
 * Create Ingestion (Support)
 *
 * Route to request the creation of a Ingestion (for support).
 */
export const supportCreateIngestion = <ThrowOnError extends boolean = false>(
  options: Options<SupportCreateIngestionData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SupportCreateIngestionResponses,
    SupportCreateIngestionErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/projects/{projectId}/pointclouds/{pointcloudId}/ingestions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get Job info
 *
 * Route to get job properties.
 */
export const getJob = <ThrowOnError extends boolean = false>(
  options: Options<GetJobData, ThrowOnError>
) =>
  (options.client ?? client).get<GetJobResponses, GetJobErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/jobs/{jobId}',
    ...options,
  });

/**
 * List Jobs by date range
 *
 * Route to list of jobs.
 */
export const listJobs = <ThrowOnError extends boolean = false>(
  options?: Options<ListJobsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListJobsResponses,
    ListJobsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/jobs',
    ...options,
  });

/**
 * Get Support User Info
 *
 * Route to get current support user info.
 */
export const getSupportMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetSupportMeData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSupportMeResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/support/me',
      ...options,
    }
  );

/**
 * Migrate files and stations out of pointcloud
 *
 * Admin route to migrate pointcloud files and stations.
 */
export const migrationPointcloudFilesAndStations = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<MigrationPointcloudFilesAndStationsData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    MigrationPointcloudFilesAndStationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/migrations/pointcloudfilesandstations',
    ...options,
  });

/**
 * Fix pointcloud duplicate usages
 *
 * Admin route to fix pointcloud duplicate usages.
 */
export const migrationFixPointcloudDuplicateUsages = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<MigrationFixPointcloudDuplicateUsagesData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    MigrationFixPointcloudDuplicateUsagesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/migrations/fixpointcloudduplicateusages',
    ...options,
  });

/**
 * Migrate pointcloud null status
 *
 * Admin route to migrate pointcloud null status.
 */
export const migrationPointcloudNullStatus = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<MigrationPointcloudNullStatusData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    MigrationPointcloudNullStatusResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/migrations/pointcloudnullstatus',
    ...options,
  });

/**
 * Export Pointclouds for all projects with sorting and filtering
 *
 * Admin route to export pointclouds.
 */
export const exportSupportPointclouds = <ThrowOnError extends boolean = false>(
  options: Options<ExportSupportPointcloudsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ExportSupportPointcloudsResponses,
    ExportSupportPointcloudsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/pointclouds/export',
    ...options,
  });

/**
 * List Pointclouds for all projects with paging and filtering
 *
 * Admin route to list of pointclouds.
 */
export const listSupportPointclouds = <ThrowOnError extends boolean = false>(
  options?: Options<ListSupportPointcloudsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListSupportPointcloudsResponses,
    ListSupportPointcloudsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/pointclouds',
    ...options,
  });

/**
 * Get Project info
 *
 * Route to get Project properties.
 */
export const getSupportProject = <ThrowOnError extends boolean = false>(
  options: Options<GetSupportProjectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetSupportProjectResponses,
    GetSupportProjectErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/projects/{projectId}',
    ...options,
  });

/**
 * Get Spark pools
 *
 * Route to get Spark pools.
 */
export const getSparkPool = <ThrowOnError extends boolean = false>(
  options?: Options<GetSparkPoolData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSparkPoolResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/support/sparkpools',
      ...options,
    }
  );

/**
 * Get Pointcloud Counts
 *
 * Route to get pointcloud counts.
 */
export const getUsageSummaryPointclouds = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetUsageSummaryPointcloudsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetUsageSummaryPointcloudsResponses,
    GetUsageSummaryPointcloudsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/usagesummary/pointclouds',
    ...options,
  });

/**
 * Get Projects Counts
 *
 * Route to get project counts.
 */
export const getUsageSummaryProjects = <ThrowOnError extends boolean = false>(
  options: Options<GetUsageSummaryProjectsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetUsageSummaryProjectsResponses,
    GetUsageSummaryProjectsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/usagesummary/projects',
    ...options,
  });

/**
 * Get Storage Used
 *
 * Route to get storage used.
 */
export const getUsageSummaryStorage = <ThrowOnError extends boolean = false>(
  options: Options<GetUsageSummaryStorageData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetUsageSummaryStorageResponses,
    GetUsageSummaryStorageErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/usagesummary/storage',
    ...options,
  });

/**
 * Get Uploader Counts
 *
 * Route to get uploader counts.
 */
export const getUsageSummaryUploaders = <ThrowOnError extends boolean = false>(
  options: Options<GetUsageSummaryUploadersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetUsageSummaryUploadersResponses,
    GetUsageSummaryUploadersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/support/usagesummary/uploaders',
    ...options,
  });

/**
 * Get Tileset info
 *
 * Route to get Tileset metadata icluding creation status.
 */
export const getTileset = <ThrowOnError extends boolean = false>(
  options: Options<GetTilesetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetTilesetResponses,
    GetTilesetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/tilesets/{tilesetId}',
    ...options,
  });

/**
 * List Tilesets
 *
 * Route to list Tilesets.
 */
export const listTilesets = <ThrowOnError extends boolean = false>(
  options: Options<ListTilesetsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListTilesetsResponses,
    ListTilesetsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/pointclouds/{pointcloudId}/tilesets',
    ...options,
  });

/**
 * Add trajectory for a classification job
 *
 * Add a trajectory that can be used in a classification job.
 */
export const createTrajectory = <ThrowOnError extends boolean = false>(
  options: Options<CreateTrajectoryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    CreateTrajectoryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/trajectories',
    ...options,
  });

/**
 * Add points to a trajectory
 *
 * Add points to a created trajectory. Points can be added with multiple calls, and in that case trajectory points would be merged using 'Index' from the request body.
 */
export const addTrajectoryPoints = <ThrowOnError extends boolean = false>(
  options: Options<AddTrajectoryPointsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    AddTrajectoryPointsResponses,
    AddTrajectoryPointsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/trajectories/{trajectoryId}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get project users
 *
 * Returns specific users of a project.
 */
export const listUsers = <ThrowOnError extends boolean = false>(
  options: Options<ListUsersData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ListUsersResponses,
    ListUsersErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users',
    ...options,
  });
